import { Context } from '@nuxt/types'
import { USER_NS } from '~/store/modules/shared/user/state'

// Routes that are also available to logged in single users
export const singleAllowedRoutes = [
  '__classified_one_click_touch',
  '__classifieds_edit',
  '__classifieds_view',
  // Audits routes redirect to non-account routes
  '__account_audits_requests_request',
  '__account_audits_requests_certificates_view'
]

// Used per-page when login is required to view the page
export default function({ route, redirect, app, store }: Context) {
  const { router } = app

  const userIsSingle = store.getters[`${USER_NS}/isSingle`]
  const userIsNotAnon = !store.getters[`${USER_NS}/isAnon`]

  const isSingleAllowedRoute =
    route.name &&
    singleAllowedRoutes.some(r => route.name?.toString().startsWith(r))

  const userIsLoggedIn = userIsNotAnon || (isSingleAllowedRoute && userIsSingle)

  if (!userIsLoggedIn) {
    const resolvedRoute = router?.resolve({
      name: '__login',
      query: { gotonext: route.fullPath, 'must-login': '1' }
    })

    const redirectUrl =
      resolvedRoute?.resolved?.matched?.length && resolvedRoute?.href
        ? resolvedRoute.href
        : `/login/?gotonext=${route.fullPath}&must-login=1`

    return redirect(redirectUrl)
  }
}
